import { displayAnswer } from "@/lib/checkins";
import { BigButton } from "./PublicShell";

export function ReviewStep({ template, visible, answers, errors, submitting, onEdit, onSubmit }) {
  const byCode = Object.fromEntries((errors || []).filter((e) => e.code).map((e) => [e.code, e.message]));
  const general = (errors || []).filter((e) => !e.code);
  return (
    <div className="space-y-6" data-testid="checkin-review">
      <div>
        <h1 className="font-display text-3xl font-bold tracking-tight text-zinc-950">Check your answers</h1>
        <p className="mt-2 text-lg text-zinc-700">You can change anything before you send it.</p>
      </div>
      {general.map((e) => (
        <p key={e.message} className="rounded-lg bg-red-50 px-4 py-3 text-base font-semibold text-red-800" role="alert" data-testid="checkin-review-error">{e.message}</p>
      ))}
      {template.sections.map((s) => {
        const qs = visible.filter((q) => q.section === s.code);
        if (!qs.length) return null;
        return (
          <section key={s.code} className="rounded-2xl border border-zinc-200 bg-white p-5">
            <h2 className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500">{s.label}</h2>
            <dl className="mt-3 divide-y divide-zinc-100">
              {qs.map((q) => (
                <div key={q.code} className="flex flex-col gap-1 py-3 sm:flex-row sm:items-start sm:justify-between sm:gap-4" data-testid={`checkin-review-${q.code}`}>
                  <div className="min-w-0">
                    <dt className="text-base text-zinc-700">{q.prompt}</dt>
                    <dd className="mt-0.5 text-lg font-semibold text-zinc-950">{displayAnswer(q, answers[q.code])}</dd>
                    {byCode[q.code] && <p className="mt-1 text-sm font-semibold text-red-700" role="alert">{byCode[q.code]}</p>}
                  </div>
                  <button
                    type="button" onClick={() => onEdit(q.code)} data-testid={`checkin-review-edit-${q.code}`}
                    className="min-h-[44px] self-start rounded-lg px-3 text-base font-semibold text-sky-800 underline underline-offset-4 hover:text-sky-950 focus:outline-none focus-visible:ring-4 focus-visible:ring-sky-400"
                  >
                    Change
                  </button>
                </div>
              ))}
            </dl>
          </section>
        );
      })}
      <p className="text-base text-zinc-700">Your answers go to your exercise team. They may not see them straight away — this is not an emergency service.</p>
      <BigButton className="w-full" onClick={onSubmit} disabled={submitting} data-testid="checkin-submit-btn">
        {submitting ? "Sending…" : "Send my progress review"}
      </BigButton>
    </div>
  );
}
